import { render, staticRenderFns } from "./WalletWithdrawModal.vue?vue&type=template&id=06606088&"
import script from "./WalletWithdrawModal.vue?vue&type=script&lang=ts&"
export * from "./WalletWithdrawModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports